import React, { useEffect, useState } from 'react';
//Header Data

//Footer Data

//Styles
import styles from './../Profile.module.scss';
import { PaginationSwitch, ContestPortfolioNavigation } from '../../../components/Profile/PortfolioNavigation/PortfolioNavigation';
import { Contest, GalleryDesign, User } from '../../../global';

import { Button, Modal } from 'react-bootstrap';
import axiosHelper from '../../../helpers/axiosHelper';
import useSWR from 'swr';
import ContestCardWLF from '../../../components/Contest/ContestCard/ContestCardWLF';
import PopUpRedirectContest from '../../../components/PopUp/PopUpRedirectContest/PopUpRedirectContest';

// const mockGalleryImages = [
//   'https://source.unsplash.com/_HqHX3LBN18/800x680',
//   'https://source.unsplash.com/OzqieLcs464/800x680',
//   'https://source.unsplash.com/RFP4D5hGTB0/800x680',
//   'https://source.unsplash.com/rvftn4hX7AY/800x680',
//   'https://source.unsplash.com/YnLJ3rM4VtI/800x680',
// ];

// const mockGalleryImagesHalf = [
//   'https://source.unsplash.com/OzqieLcs464/800x680',
//   'https://source.unsplash.com/rvftn4hX7AY/800x680',
//   'https://source.unsplash.com/YnLJ3rM4VtI/800x680',
// ];

interface Props {
  user: User;
  loggedUser: User | null;
  breadcrumbs: (breadcrumbs: string) => void;
}

const ContestsWLF: React.FC<Props> = ({ user, loggedUser, breadcrumbs }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [layoutPortfolio, setLayoutPortfolio] = useState(1);
  // const layoutPortfolio = useStoreState(DslStore, getLayoutPortfolio);
  // const pageNumber = useStoreState(DslStore, getPortfolioPageNumber);
  // const portfolioDesigns = useStoreState(DslStore, getPortfolioDesigns);
  // const clientContests = useStoreState(DslStore, getClientContests);
  // const cocreationcontests = useStoreState(DslStore, getAllCoCreationContests);
  const [popup, setPopup] = useState(false);
  const [popupLink, setPopupLink] = useState('');
  const date = new Date().toISOString();

  const [visibleDesign, setVisibleDesign] = useState<GalleryDesign[]>([]);
  const [visibleContests, setVisibleContests] = useState<Contest[]>([]);
  const [key, setKey] = useState(0);
  const { data, error, isLoading } = useSWR('cid|' + user.id, axiosHelper.clientContestsFetcher);
  const [linkToDescription, setLinkToDescription] = useState('');

  useEffect(() => {
    console.log('ContestsWLF');
  }, []);
  useEffect(() => {
    console.log(data);
    if (data) {
      setVisibleContests(data);
    }
  }, [data]);

  useEffect(() => {
    breadcrumbs('Contests');

    // props.breadcrumbs && props.breadcrumbs(`${props.user.userType === 'D' ? 'Portfolio' : 'Contests'}`);
    // console.log(clientContests);
  }, [breadcrumbs]);

  // const arraysfill = () => {
  //   let chunkSize = 20;
  //   let startchunk = (pageNumber - 1) * chunkSize;
  //   let tempArray: GalleryDesign[] = [];
  //   let rightArray: GalleryDesign[] = [];
  //   console.log(tempArray);
  //   setVisibleDesign(tempArray);
  // };

  // const arrayContestsFill = () => {
  //   let chunkSize = 20;
  //   let startChunk = (pageNumber - 1) * chunkSize;
  //   let tempArray: Contest[] = [];
  //   setVisibleContests(tempArray);
  // };

  // const statusText = (contest: Contest) => {
  //   if (contest.contestType !== 'Co-creation') {
  //     if (contest.isClosed && contest.endVotingDate) {
  //       return `closed: ${startDateString(contest.endVotingDate)}`;
  //     } else if (contest.isClosed && contest.endUploadDate) {
  //       return `closed: ${startDateString(contest.endUploadDate)}`;
  //     } else if (date < contest.startDate) {
  //       return 'coming soon';
  //     } else if (date < contest.endUploadDate) {
  //       return `ends:  ${startDateString(contest.endUploadDate)}`;
  //     } else if (contest.endVotingDate && date < contest.endVotingDate) {
  //       return `community vote`;
  //       // console.log(endVotingDate);
  //       // console.log(date > endVotingDate);
  //     } else if (contest.endVotingDate && date > contest.endVotingDate && !contest.isClosed) {
  //       return `client vote`;
  //     } else if (date > contest.endUploadDate && !contest.isClosed) {
  //       return `client vote`;
  //     }
  //   } else {
  //     const contestAttached: CoCreationContest[] = [];
  //     // let stat: ContestStatus = 'ongoing';
  //     // cocreationcontests.map((item: CoCreationContest) => {
  //     //   if (item.mainContest.id === contest.id) {
  //     //     contestAttached.push(item);
  //     //   }
  //     // });

  //     contestAttached.map((item: CoCreationContest, index: number) => {
  //       // console.log(item);
  //       // console.log(item);
  //       // console.log(stat);
  //       // console.log(contestAttached.length);
  //       if (stat !== 'closed' && index < contestAttached.length)
  //         if (item.isClosed) {
  //           stat = 'closed';
  //         } else if (date < item.startUploadDate) {
  //           stat = 'coming-soon';
  //         } else if (date < item.endUploadDate) {
  //           stat = 'ongoing';
  //         } else if (item.endVotingDate && date < item.endVotingDate) {
  //           stat = 'community-vote';
  //         } else if (item.endVotingDate && date > item.endVotingDate && !item.isClosed) {
  //           stat = 'client-vote';
  //         } else if (date > item.endVotingDate && !item.isClosed) {
  //           stat = 'client-vote';
  //         }
  //     });
  //     return stat;
  //   }
  //   return `standby`;
  // };
  const handleExternalLink = (url: string, popupText: string) => {
    setPopupLink(url);
    setLinkToDescription(popupText);
    setPopup(true);
  };

  const handleClick = (e: any) => {
    let url: string = e.split('/')[2];
    let linkto = e.split('/')[3];
    if (url.includes('bit.ly')) {
      // console.log(url);
      // setPopupLink(e);
      // setPopup(!popup);
      // console.log(linkto);
      //redirect hidden menu
    } else {
      setPopupLink(e);
      setPopup(!popup);
    }
  };

  return (
    <div className="bg-light-gray" key={key}>
      <main className={`${styles.profileWrapper} container pt-5  mb-5 px-sm-0    `}>
        <PopUpRedirectContest popup={popup} description={linkToDescription} close={() => setPopup(false)} link={popupLink} />

        {/* <Modal show={popup} onHide={() => setPopup(!popup)} className={`d-flex flex-column justify-content-center`}>
          <div className="d-flex flex-column justify-content-center text-center">
            <Modal.Header className="d-flex justify-content-center">
              <h3>
                <b> You are leaving desall.com </b>
              </h3>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center">
              <h5>You will be redirected to the Artsana platform innovation.artsana.com</h5>
            </Modal.Body>
          </div>
          <Modal.Footer className="d-flex flex-row justify-content-between">
            <Button className="btn-red " onClick={() => setPopup(!popup)}>
              Close
            </Button>
            <a href={popupLink} target="_self">
              <Button className="btn-success" onClick={() => setPopup(!popup)}>
                Continue
              </Button>
            </a>
          </Modal.Footer>
        </Modal> */}
        <div className={` row `}>
          {/* Projecst ============================================================================= */}
          <ContestPortfolioNavigation onChangeLayout={setLayoutPortfolio} />
        </div>
        <div className="row  ">
          {visibleContests.map((item, index) => (
            <ContestCardWLF wrap={true} key={index} contest={item} clickHandler={handleExternalLink} />
          ))}
        </div>
        <div className="row ">
          <div className="col-12  d-flex justify-content-sm-start justify-content-md-end">{visibleDesign.length > 0 ? <PaginationSwitch onChangePage={setPageNumber} /> : ''}</div>
        </div>
      </main>
    </div>
  );
};

export default ContestsWLF;
